export interface UserInfo {
  id: string;
  name: string;
  preferredUsername: string;
  email: string;
  emailVerified: boolean;
  locale: string;
  roles: string[];
  createdAt: Date;
}

export const ROLE_PIGLET_LOGIN = 'ROLE_PIGLET_LOGIN';
export const ROLE_MANAGE_ALERTS = 'ROLE_MANAGE_ALERTS';
export const ROLE_MANAGE_USERS = 'ROLE_MANAGE_USERS';
export const ROLE_MANAGE_REALMS = 'ROLE_MANAGE_REALMS';
export const ROLE_ARTICLES_MANAGE = 'ROLE_ARTICLES_MANAGE';
export const ROLE_ARTICLES_WRITE = 'ROLE_ARTICLES_WRITE';
export const ROLE_ARTICLES_DELETE = 'ROLE_ARTICLES_DELETE';
export const ROLE_SUPER_ADMINISTRATOR = 'ROLE_SUPER_ADMINISTRATOR';
export const ROLE_BAN_USERS = 'ROLE_BAN_USERS';
export const ROLE_LOCK_USERS = 'ROLE_LOCK_USERS';
export const ROLE_EXCEED_GAME_ACCOUNT_LIMIT = 'ROLE_EXCEED_GAME_ACCOUNT_LIMIT';
export const ROLE_CANCEL_BAN = 'ROLE_CANCEL_BAN';
export const ROLE_FORGIVE_BAN = 'ROLE_FORGIVE_BAN';
export const ROLE_FALSE_POSITIVE_BAN = 'ROLE_FALSE_POSITIVE_BAN';
export const ROLE_MANAGE_CREDIT_CARD = 'ROLE_MANAGE_CREDIT_CARD';
export const ROLE_VIEW_WEB_EXCEPTIONS = 'ROLE_VIEW_WEB_EXCEPTIONS';
